import { Image, Swiper } from "antd-mobile";
import { useNavigate } from "react-router-dom";
import { useGetEventList } from "../../../Event/hooks/event.hook";

import { useAuth } from "../../../../context/AuthContext";
import { envChangeType } from "../../../../plugins/utils";
import "./style.scss";

const Banner = () => {
  const { data, isLoading, isError } = useGetEventList();
  const { lang } = useAuth();
  const navigate = useNavigate();
  const renderDefaultBanner = (_lang = null) => {
    return (
      <Image
        src={`${envChangeType("REACT_APP_CDN_URL")}/imgs/banner/agent-default-banner-${_lang ? _lang : lang}.png`}
        fallback={
          <Image
            src={`${envChangeType("REACT_APP_CDN_URL")}/imgs/banner/agent-default-banner-en.png`}
            fallback={
              <Image
                src={`${envChangeType("REACT_APP_GLOBAL_CDN")}/banner/agent-default-banner-${_lang ? _lang : lang}.png`}
                fallback={
                  <Image
                    src={`${envChangeType("REACT_APP_GLOBAL_CDN")}/banner/agent-default-banner-en.png`}
                  />
                }
              />
            }
          />
        }
      />
    );
  };

  return (
    <>
      {isLoading || isError || data.length <= 0 ? (
        renderDefaultBanner()
      ) : (
        <Swiper autoplay={true} autoplayInterval={5000} loop={true}>
          {data.map((item) => {
            return (
              <Swiper.Item key={item.id}>
                <Image
                  onContainerClick={() => {
                    navigate("/home/event");
                  }}
                  src={`${envChangeType("REACT_APP_CDN_URL")}/${item.img_url}`}
                  // height={111}
                  fit="cover"
                  className="home-banner-image"
                  // style={{
                  //   width: "100vw",
                  //   height: "calc(100vw / var(--banner-width-height-ratio))",
                  // }}
                />
              </Swiper.Item>
            );
          })}
        </Swiper>
      )}
    </>
  );
};

export default Banner;
